<template>
  <!-- Auth Stnakcbar -->
  <v-snackbar
    v-model="authSnackbar"
    class="hidden-xs-only"
    color="success"
    :timeout="1500"
    bottom
    right
    id="main_snack_bar"
  >
    <v-icon class="mr-3">check_cricle</v-icon>
    <h5>You are now signed in!</h5>
    <v-btn dark text @click="authSnackbar = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AuthSnackbar",
  data() {
    return {
      authSnackbar: false
    };
  },
  watch: {
    // if we had no value for user before - show snackbar
    user(newValue, oldValue) {
      if (oldValue === null) {
        this.authSnackbar = true;
      }
    }
  },
  computed: {
    ...mapGetters(["user"])
  }
};
</script>
